import type { SupportedLocale } from '@erp/shared';

export const partnerUsabilityTranslations = {
  de: {
    errorHint: 'Wählen Sie eine Angabe aus, um sie zu korrigieren.',
    sectionsHint:
      'Öffnen Sie den passenden Bereich. Speichern und Abbrechen bleiben unten erreichbar.',
  },
  en: {
    errorHint: 'Select a field to correct it.',
    sectionsHint: 'Open the section you need. Save and Cancel remain available at the bottom.',
  },
  fr: {
    errorHint: 'Sélectionnez un champ pour le corriger.',
    sectionsHint:
      'Ouvrez la rubrique souhaitée. Enregistrer et Annuler restent accessibles en bas.',
  },
  es: {
    errorHint: 'Seleccione un campo para corregirlo.',
    sectionsHint: 'Abra la sección que necesite. Guardar y Cancelar permanecen accesibles abajo.',
  },
  tr: {
    errorHint: 'Düzeltmek için bir alan seçin.',
    sectionsHint:
      'İhtiyacınız olan bölümü açın. Kaydet ve İptal düğmeleri altta erişilebilir kalır.',
  },
} satisfies Record<SupportedLocale, Record<string, string>>;
